/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionIssuersCreate } from "../funcs/remoteSessionIssuersCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteSessionIssuer } from "../models/components/remotesessionissuer.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateRemoteSessionIssuerRequest,
  CreateRemoteSessionIssuerSecurity,
} from "../models/operations/createremotesessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateRemoteSessionIssuerMutationVariables = {
  request: CreateRemoteSessionIssuerRequest;
  security?: CreateRemoteSessionIssuerSecurity | undefined;
  options?: RequestOptions;
};

export type CreateRemoteSessionIssuerMutationData = RemoteSessionIssuer;

export type CreateRemoteSessionIssuerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createRemoteSessionIssuer remoteSessionIssuers
 *
 * @remarks
 * Create a new remote_session_issuer.
 */
export function useCreateRemoteSessionIssuerMutation(
  options?: MutationHookOptions<
    CreateRemoteSessionIssuerMutationData,
    CreateRemoteSessionIssuerMutationError,
    CreateRemoteSessionIssuerMutationVariables
  >,
): UseMutationResult<
  CreateRemoteSessionIssuerMutationData,
  CreateRemoteSessionIssuerMutationError,
  CreateRemoteSessionIssuerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateRemoteSessionIssuerMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateRemoteSessionIssuer(): MutationKey {
  return ["@gram/client", "remoteSessionIssuers", "create"];
}

export function buildCreateRemoteSessionIssuerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateRemoteSessionIssuerMutationVariables,
  ) => Promise<CreateRemoteSessionIssuerMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateRemoteSessionIssuer(),
    mutationFn: function createRemoteSessionIssuerMutationFn({
      request,
      security,
      options,
    }): Promise<CreateRemoteSessionIssuerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(remoteSessionIssuersCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
